
import { useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import swal from "sweetalert";
import Status from '../../../components/ui/Status';
import AssetSCSSearchModal from './AssetSCSSearchModal';
import AssetSCSDetail from './AssetSCSDetail';
import { toast } from 'react-toastify';

const AssetSCSList = ({history}) => {
    
    const assetScsUrl               =   BACKOFFICE_BASE_URL + '/scs';
    
    const access_token              =   useSelector(state => state.auth.access_token);
    const permissions               =   useSelector(state => state.app.acl_info?.permissions || []);
    const searchAssetSCSModalRef    =   useRef(null);

    const [listingLoading, setListingLoading]           =   useState(false);
    const [scsListing, setScsListing]                   =   useState([]);
    const [listingMeta, setListingMeta]                 =   useState(null);
    const [scsFilterForm, setSCSFilterForm]             =   useState({});
    const [formSearchedElems, setFormSearchedElems]     =   useState([]);
    const [minimizeTable, setMinimizeTable]             =   useState(false); 
    const [detailData, setDetailData]                   =   useState(null);
    const [assetScsId, setAssetScsId]                   =   useState(null);

    useEffect                 (()           => {
        loadListingTblData(1);
    }, [formSearchedElems]);

    const searchModalHandle      =    ()    => {
        if (searchAssetSCSModalRef.current) {
            searchAssetSCSModalRef.current.initModalHandler()
        }
    }
    const addEditModalHandle         =    (id = null)   => {
        if(id) {
            history.push('/asset_scs_add?asset_scs_id=' + id);
        }else {
            history.push('/asset_scs_add');
        }
    }
    const detailModalHandle      =    (id)   => {
        setMinimizeTable(true);
        setAssetScsId(id);
    }

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 50, ...scsFilterForm };
        HttpAPICall.withAthorization('GET', assetScsUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setScsListing(respData.data);
            setListingMeta({
                'from'          :   respData.from, 
                'to'            :   respData.to, 
                'total'         :   respData.total, 
                'last_page'     :   respData.last_page, 
                'per_page'      :   respData.per_page, 
                'current_page'  :   respData.current_page
            });
        }).then(() => setListingLoading(false));
    };
    
    const submitSearchForm = (searchedElems, assetScsSearchForm) => {
        setFormSearchedElems(searchedElems);
        setSCSFilterForm(assetScsSearchForm);
    };

    const assetScsSearchClear = () => {
        setFormSearchedElems([]);
        setSCSFilterForm({});
        searchAssetSCSModalRef.current.clearSearchForm()
    };

    const deleteAssetScs   =   (id)  =>  {
        swal({
            title: "Delete",
            text: "Are you sure want to delete this permanently?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                // HttpAPICall.withAthorization('DELETE', assetScsUrl + '/delete/' + id, access_token,{},{},(resp) => {
                //     toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                //     loadListingTblData(1)
                // });
            }
        });
    }

    const handleStatus  =   (id)  => {
        swal({
            title: "Delete",
            text: "Are you sure want to change status?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        })
        .then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('PUT', assetScsUrl + '/status/' + id, access_token,{},{},(resp) => {
                    toast.success(resp.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    loadListingTblData(1)
                });
            }
        });
    }

    const closeViewDetails  =   ()  =>  {
        setMinimizeTable(false);
        setAssetScsId(null);
        setDetailData(null);
    }
    const assetSCSDetailData   =   (data)  => {
        setDetailData(data)
    }

    const assetScsJsx = () => {
        return (
            <>
            <div className="page_title row m0">
                <div className={minimizeTable ? "col-3" : "col-12"}>
                    <h3>Asset SCS List</h3>
                    <div className="text-end mt15">
                        {
                        (!minimizeTable) 
                        ?
                        <>
                        {
                            permissions.includes('asset_scs_add') &&
                            <button type="button" className="btn btn-primary" onClick={() => addEditModalHandle(null)}>New</button>
                        }
                            <button type="button" className="btn btn-secondary" onClick={searchModalHandle} disabled={listingLoading}>
                                <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                            </button>
                        </>
                        : null
                        }
                    </div>
                </div>
            {
            minimizeTable
                ? (
                    <div className="col-9 tap_border_left">
                        <h3>Asset SCS :  {detailData?.name}</h3>
                        <div className="text-end mt15">
                            <button type="button" className="btn btn-secondary" onClick={closeViewDetails}>
                                <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>
                )
                : null
            }
            </div>

            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', minimizeTable ? 'col-3' : 'col-12'].join(' ')} >{scsListingJsx()}</div>
                    {
                        minimizeTable 
                        ? <div className="col-9 pr4 pl4"><div className="bg-white p-2" style={{ height: "100%" }}><AssetSCSDetail assetScsId={assetScsId} assetSCSDetailData={assetSCSDetailData}/></div></div> 
                        : null
                    }
                </div>
            </div>
            </>
        );
    };
    const scsListingJsx = () => {
        return (
            <>
                {
                    !minimizeTable && <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={assetScsSearchClear} />
                }
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            {
                                minimizeTable 
                                ?
                                <th style={{ width: "19%" }}>Name</th>
                                :
                                <>
                                    <th style={{ width: "5%" }}>S.No</th>
                                    <th style={{ width: "27%" }}>Name</th>
                                    <th style={{ width: "27%" }}>Asset Type</th>
                                    <th style={{ width: "25%" }}>Section</th>
                                    <th style={{ width: "10%" }}>Status</th>
                                    <th style={{ width: "6%" }}>Action</th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                            : (scsListing && scsListing.length > 0
                                ? (scsListing.map((item, index) => (
                                    <tr key={index}>
                                        {
                                            minimizeTable 
                                            ?
                                            <td><Link onClick={() => detailModalHandle(item.id)} >{item.name}</Link></td>
                                            :
                                            <>
                                                <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                                <td><Link onClick={() => detailModalHandle(item.id)} >{item.name}</Link></td>
                                                <td>
                                                    {item.asset_type}
                                                </td>
                                                <td>
                                                    {item.section?.component}
                                                </td>
                                                <td>
                                                    <Status color={item.status.status_color_code}>{item.status.status_text}</Status>
                                                </td>
                                                <td className='text-center'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    { permissions.includes('asset_scs_edit') &&
                                                        <li onClick={() => addEditModalHandle(item.id)}><Link className="dropdown-item" role="button">Edit</Link></li>
                                                    }
                                                    { permissions.includes('asset_scs_edit') &&
                                                        <li onClick={() => handleStatus(item.id)}><Link className="dropdown-item" role="button">{item.status.status == 1 ? 'Inactive' : 'Active'}</Link></li>
                                                    }
                                                        {/* <li onClick={() => deleteAssetScs(item.id)}><Link className="dropdown-item" role="button">Delete</Link></li> */}
                                                    </ul>
                                                </td>
                                            </>
                                        }
                                    </tr>
                                )))
                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                        }
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Asset SCS Listing</title></Helmet>
            {assetScsJsx()}
            <AssetSCSSearchModal ref={searchAssetSCSModalRef} submitSearchFormProp={submitSearchForm}/>
        </ApplicationLayout>
    );
};

export default AssetSCSList;



